export default "__VITE_ASSET__BSb3XgnS__"